<template>
    <div>
        <Breadcrumb>
            <span><router-link :to="{ path: '/' }">Početna</router-link></span>
            <span class="separetor">/</span>
            <span class="font-weight-bolder"><router-link :to="{ name: 'dojavi-vijest' }">Dojavi vijest</router-link></span>
        </Breadcrumb>
        <section class="has-sidebar u-padding-tb-40">
            <div class="container">
                <div class="row" data-sticky_parent>
                    <div class="col-lg-12 content-wrapper">
                        <div data-sticky_column>
                            <div class="contact-form">
                                <div class="form-title">
                                    <h4>Dojavi vijest</h4>
                                </div>
                                <div class="form-body">
                                    <div class="m-post-content">
                                        <div ref="successMessage" class="report-news-success" style="display:none">
                                            <img src="/src/assets/img/checkmark.png" alt="Success Reported News">
                                            <h3 class="text-center mt-3">Poruka uspješno poslana. Hvala Vam!</h3>
                                        </div>
                                        <div ref="form">
                                            <div class="col-md-12">
                                                <div class="card">
                                                    <div class="card-body">
                                                        <h5 class="card-title"> Dojavi vijest i postani Politicki.ba
                                                            čitatelj-reporter!</h5>
                                                        <p class="card-text">Ako ste svjedočili nekom događaju i želite
                                                            podijeliti informacije, fotografije ili video javite se portalu
                                                            Politicki.ba.<br /><br />

                                                            Kontaktirajte nas i ako imate pitanja na koja ne možete pronaći
                                                            odgovor. Politicki.ba istražuje za vas.<br>
                                                            Želite prijaviti korupciju, nepravilnosti i neregularnosti u
                                                            administraciji, pošaljite dokaze. Politicki.ba je u službi
                                                            građana.<br><br>

                                                            Sve dojave su anonimne, a najkorisnije će biti
                                                            nagrađene.<br><br>


                                                            Sve možete slati putem formulara ispod, na e-mail <a
                                                                v-bind:href="'mailto:' + contactInfo.email">{{
                                                                    contactInfo.email }}</a> ili javiti na telefon <a
                                                                href="javascript:void(0)">{{ contactInfo.phoneNumber }}</a>,
                                                            a možete poslati poruku na Facebook fan pageu portala
                                                            Politicki.ba.</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-group col-md-12 mt-3">
                                                <label for="email">Email</label>
                                                <input id="email" type="text" class="form-control" v-model="email"
                                                    placeholder="Vaša e-mail adresa" />
                                                <span ref="emailReqError" class="text-danger" style="display:none">E-mail je
                                                    obavezan.</span>
                                                <span ref="emailNotValidError" class="text-danger"
                                                    style="display:none">E-mail nije u ispravnom formatu.</span>
                                            </div>
                                            <div class="form-group col-md-12">
                                                <label for="text">Poruka</label>
                                                <textarea id="text" class="form-control" v-model="text" rows="6"
                                                    placeholder="Poruka" />
                                                <span ref="messageReqError" class="text-danger" style="display:none">Poruka
                                                    je obavezna.</span>
                                            </div>
                                            <div class="form-group col-md-12">
                                                <input type="file" id="files" ref="files" multiple
                                                    v-on:change="handleFilesUpload()" />
                                            </div>
                                            <div class="form-group col-md-12">
                                                <button id="submitBtn" class="btn btn-primary"
                                                    v-on:click="submitForm()">Pošalji</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import axios from "axios";
import Breadcrumb from '../components/Breadcrumb'
import { API_URL } from "../common/config";
import { AboutService } from '../common/api.service'

export default {
    name: "ReportNews",
    components: { Breadcrumb },
    metaInfo: {
        title: 'Dojavi vijest',
    },
    data() {
        return {
            email: '',
            text: '',
            files: '',
            hasErrors: false,
            contactInfo: {}
        }
    },
    mounted() {
        window.scrollTo(0, 0);
    },
    created() {
        this.fetchData();
    },
    methods: {
        fetchData: function () {
            AboutService.getContactInfo().then(res => {
                this.contactInfo = res.data;
                console.log(res.data)
            });
        },
        handleFilesUpload() {
            this.files = this.$refs.files.files;
        },
        submitForm() {
            if (!this.isFormValid())
                return false;
            let formData = new FormData();
            for (var i = 0; i < this.files.length; i++)
                formData.append('files', this.files[i]);
            formData.append('email', this.email);
            formData.append('text', this.text);
            var $submitBtn = document.getElementById("submitBtn");
            $submitBtn.innerText = "Šaljem...";
            $submitBtn.disabled = true;
            var $component = this;
            axios.post(API_URL + '/ReportedNews/Add',
                formData, { headers: { 'Content-Type': 'multipart/form-data' } }
            ).then(function () {
                $submitBtn.innerText = "Potvrdi";
                $submitBtn.disabled = false;
                $component.$refs.form.style.display = "none";
                $component.$refs.successMessage.style.display = "block";
                window.scrollTo(0, 0);
            })
                .catch(function (error) {
                    $submitBtn.disabled = false;
                });
        },
        validateEmail(email) {
            const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        },
        isFormValid: function () {
            this.hasErrors = false;
            this.$refs.emailReqError.style.display = "none";
            this.$refs.emailNotValidError.style.display = "none";
            this.$refs.messageReqError.style.display = "none";

            if (this.email === '') {
                this.hasErrors = true;
                this.$refs.emailReqError.style.display = "block";
            }
            else if (!this.validateEmail(this.email)) {
                this.hasErrors = true;
                this.$refs.emailNotValidError.style.display = "block";
            }

            if (this.text === '') {
                this.hasErrors = true;
                this.$refs.messageReqError.style.display = "block";
            }
            return !this.hasErrors;
        }
    }
}
</script>

<style scoped>.widget--border-box.social-grid .media-lists li {
    flex: 0 0 25.000%;
    -webkit-flex: 0 0 25.000%;
    -ms-flex: 0 0 25.000%;
}

.report-news-success img {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 250px;
    -moz-user-select: none;
    -webkit-user-select: none;
    user-select: none;
}</style>


// WEBPACK FOOTER //
// src/components/ReportNews.vue